module.exports = __webpack_public_path__ + "img/icon_primary_menu_support@2x.7d4c5546.png";